<template>
    <div class="top-nav-right">
        <a class="login-btn cursor"
           v-show="!authenticated"
           @click.prevent="showModal=true">
            Log In <i class="fa fa-sign-in" aria-hidden="true"></i>
        </a>
        <el-dropdown class="login-btn " trigger="click" style="color:white;cursor:pointer" @command="events" v-if="authenticated">
            <span class="el-dropdown-link ">
                 {{username}} <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item style="border-bottom: solid 1px #ddd" v-if="user.role.slug !== 'donor' && user.fundraiser && user.fundraiser.published_at"><a :href="dynamicItem.url" style="color:#606266"><i
                    class="fa fa-home"></i> {{dynamicItem.name}}</a></el-dropdown-item>
                <el-dropdown-item v-if="user.role.slug === 'teacher' && user.fundraiser && user.fundraiser.published_at" style="border-bottom: solid 1px #ddd" command="profile"><i class="fa fa-user"></i>
                    Profile Image
                </el-dropdown-item>
                <el-dropdown-item v-if="user.role.slug !== 'staff' && user.fundraiser && user.fundraiser.published_at" style="border-bottom: solid 1px #ddd" command="password"><i class="fa fa-key"></i>
                    Profile Password
                </el-dropdown-item>
                <el-dropdown-item v-if="!user.fundraiser && user.role.slug !== 'staff'">
                    <a href="/teachers/information">
                        <i class="fas fa-edit"></i>
                        Continue signup
                    </a>
                </el-dropdown-item>
                <el-dropdown-item v-if="user.role.slug === 'staff'">
                    <a href="/admin-panel/resources/fundraisers">
                        <i class="fas fa-edit"></i>
                        Go to Admin
                    </a>
                </el-dropdown-item>
                <el-dropdown-item command="logout"><i class="fas fa-sign-out" aria-hidden="true"></i> Logout
                </el-dropdown-item>

            </el-dropdown-menu>
        </el-dropdown>
        <form action="/logout" method="POST" v-show="false" id="logoutForm">
            <input type="hidden" name="_token" :value="csrf_token">
        </form>
        <slot name="socials"></slot>
        <Modal title="Login"
               v-model="showModal"
               ok-text="Login"
               class-name="vertical-center-modal login-modal">
            <form :action="loginUrl" method="POST" :id="id">
                <div class="single-row">
                    <h6 class="title-6" :for="'input-email-'+ id" :class="{'red-hover': emailError !== ''}">Email address*</h6>
                    <input type="email"
                           @keyup="validateEmailInput"
                           @blur="validateEmailInput"
                           name="email"
                           v-model="email"
                           class="input-field"
                           aria-describedby="emailHelp"
                           placeholder="Enter email" :class="{'red-hover': emailError !== ''}">
                    <!--<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.-->
                    <!--</small>-->
                    <!--<div class="text-danger" v-show="emailError !== ''">-->
                        <!--<p class="text-danger">{{emailError}}</p>-->
                    <!--</div>-->
                </div>
                <br>
                <div class="form-group">
                    <h6 class="title-6" :for="'input-password-'+ id" :class="{'red-hover': passwordError !== '' }">Password*</h6>
                    <input type="password"
                           @keyup="validatePasswordInput"
                           name='password'
                           v-model="password"
                           class="input-field"
                           placeholder="Password"
                           :class="{'red-hover': passwordError}">
                    <!--<div class="text-danger" v-show="passwordError !== ''">-->
                        <!--<p class="text-danger">{{passwordError}}</p>-->
                    <!--</div>-->
                </div>
                <div class="form-group">
                    <h6 class="title-6"><a :href="reset_password">Forgot your password?</a></h6>
                </div>
                <!--<div class="form-group form-check">-->
                <!--<input type="checkbox" class="form-check-input" :id="'remember-me-'+ id">-->
                <!--<label class="form-check-label" :for="'remember-me-'+ id">Check me out</label>-->
                <!--</div>-->
                <input type="hidden" name="_token" :value="csrf_token">
                <!--<button type="submit" class="btn btn-primary">Submit</button>-->
            </form>
            <div slot="footer">
                <div class="single-row text-right">
                    <button class="solid-btn outline"
                            @click="showModal=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click.prevent="submit(id)"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Login
                    </button>
                </div>
            </div>
        </Modal>
        <Modal title="Change Password"
            v-model="showPasswordModal"
            ok-text="Profile"
            class-name="vertical-center-modal">
            <div>
                <div class="single-row">
                    <h6 class="title-6" :class="{'red-hover': changePasswordErrors.newPassword}">Current Password*</h6>
                    <input type="password" v-model="currentPass" class="input-field"
                           placeholder="Enter your current password"
                           :class="{'red-hover': changePasswordErrors.currentPassword}">
                </div>
                <!--<p class="text-danger" v-show="changePasswordErrors.currentPassword">This field is required</p>-->
                <br>
                <div class="form-group">
                    <h6 class="title-6" :class="{'red-hover': changePasswordErrors.newPassword}">New password*</h6>
                    <input type="password" v-model="newPass" class="input-field" placeholder="Min 8 characters"
                           :class="{'red-hover': changePasswordErrors.newPassword}">
                </div>
                <!--<p class="text-danger" v-show="changePasswordErrors.newPassword">This field is required</p>-->
                <br>
                <div class="form-group">
                    <h6 class="title-6" :class="{'red-hover': changePasswordErrors.confirmPassword}">Confirm password*</h6>
                    <input type="password" v-model="confirmPass" class="input-field"
                           placeholder="Confirm your new password"
                           :class="{'red-hover': changePasswordErrors.confirmPassword}">
                </div>
                <!--<p class="text-danger" v-show="changePasswordErrors.confirmPassword">Passwords do not match</p>-->
            </div>
            <div slot="footer">
                <div class="single-row text-right">
                    <button class="solid-btn outline"
                            @click="showModal=false"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Cancel
                    </button>
                    <button class="solid-btn"
                            @click.prevent="changePassword()"
                            style="width: auto; padding-right: 15px; padding-left: 15px">
                        Change
                    </button>
                </div>
            </div>
        </Modal>
        <Modal title="Teacher image profile"
               v-model="showAvatarModal"
               ok-text="Ok"
               class-name="vertical-center-modal text-center login-modal">
            <el-upload class="avatar-"
                       style="margin-top: 5px"
                       name="file"
                       :action="uploadUri"
                       :multiple="false"
                       :show-file-list="false"
                       :on-success="handleAvatarSuccess"
                       :before-upload="beforeAvatarUpload">
                    <template slot="trigger">
                        <div class="teacher-avatar-modal" id="imageUploader" v-if="imageUrl" :style="'background-image: url('+imageUrl+')'"></div>
                        <!--<img id="imageUploader" v-if="imageUrl" :src="imageUrl" class="avatar">-->
                        <i id="triggerIcon" v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </template>
                <div class="edit-mask">
                    <i class="fa fa-trash close" v-if="imageUrl!==''" @click.prevent="showRemoveAvatarModal=true"></i>
                    <div class="click-mask" @click="openBrowserImage">
                        <!--<img class="centerImage" src="/images/edit-image-icon.png" alt="" width="40px" height="40px">-->
                    </div>
                </div>
            </el-upload>
            <p class="max-size">Max image size: <br> 224px x 224px</p>
            <div slot="footer">
            </div>
        </Modal>
        <modal title="Remove Avatar"
               v-model="showRemoveAvatarModal"
               class-name="vertical-center-modal warning-modal">
            <p style="font-size: 14pt">This action will remove this image permanently, do want continue?</p>
            <template slot="footer">
                <div class="text-center">
                    <button class="solid-btn outline" @click="showRemoveAvatarModal=false">No</button>
                    <button class="solid-btn" @click="removeImage">Yes</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: null,
                id: '',
                loginUrl: '',
                emailError: '',
                passwordError: '',
                csrf_token: '',
                authenticated: false,
                showModal: false,
                email: '',
                username: '',
                password: '',

                showPasswordModal: false,
                showRemoveAvatarModal:false,
                currentPass: '',
                newPass: '',
                confirmPass: '',
                validatingPassword: false,

                showAvatarModal: false,
                imageUrl: '',
                uploadUri: '',
                reset_password: '',
                dialogVisible:false,
            }
        },
        computed: {
            changePasswordErrors() {
                return {
                    'currentPassword': this.validatingPassword && this.currentPass.trim() === "",
                    'newPassword': this.validatingPassword && this.newPass.length < 8,
                    'confirmPassword': this.validatingPassword && (this.confirmPass !== this.newPass),
                }
            },
            passwordPayload() {
                return {
                    'current_password': this.currentPass,
                    'new_password': this.newPass,
                    'confirm_password': this.confirmPass,
                }
            },
            dynamicItem() {
                let user = this.$root.$refs.kinf.user;
                if (user != null) {
                    // console.log(user.role.slug);
                    if (user.role.slug === 'staff') {
                        return {
                            url: window.App.globalData.routes.user_home,
                            name: 'Admin Panel'
                        };
                    }
                    return {
                        url: window.App.globalData.routes.user_home,
                        name: 'My fundraiser'
                    }
                }
            }
        },
        mounted() {
            window.kinfEvents.$on('ErrorsPage', (payload) => {
                if(window.App.current_route == "password.request"){
                    return false;
                }
                if (payload.error[0].email !== undefined) {
                    this.emailError = payload.error[0].email[0];
                }
                if (payload.error[0].password !== undefined) {
                    this.passwordError = payload.error[0].password[0];
                }
                if (payload.old !== undefined && payload.old.email !== undefined) {
                    this.email = payload.old.email;
                }

                if (this.emailError !== '' || this.passwordError !== '') {
                    this.showModal = true;
                }
            });

            kinfEvents.$on('TeachersAvatarRemoved',ev=>{
                this.imageUrl = ''
            });

            kinfEvents.$on('OpenLogin',ev=>{
                this.showModal=true;
            });

            this.authenticated = this.$root.$refs.kinf.auth;
            this.username = this.authenticated ? this.$root.$refs.kinf.user.name : '';
            this.csrf_token = this.$root.$refs.kinf.appData.csrf_token;
            this.loginUrl = this.$root.$refs.kinf.appData.globalData.routes.login;
            this.uploadUri = this.$root.$refs.kinf.appData.globalData.routes.upload_image;
            this.imageUrl = this.authenticated && this.$root.$refs.kinf.user.avatar !== null
                ? this.$root.$refs.kinf.user.avatar
                : '';
            this.user = this.$root.$refs.kinf.user;
            this.reset_password = this.$root.$refs.kinf.appData.globalData.routes.reset_password;
        },
        methods: {
            page() {
                return this.$root.$refs.page;
            },
            submit(id) {
                // console.log('login');
                $('#' + id).submit();
            },
            logout() {
                $('#logoutForm').submit();
            },
            events(ev) {
                switch (ev) {
                    case 'logout':
                        this.logout();
                        break;
                    case 'password':
                        this.showPasswordModal = true;
                        break;
                    case 'profile':
                        this.showAvatarModal = true;
                        break;
                }
            },
            validateEmailInput(){
                if(this.email.trim()!=='' && this.validateEmail(this.email.trim())){
                    this.emailError = '';
                }else{
                    this.emailError = 'invalid email'
                }
                if(!this.email.trim().length){
                    this.emailError = 'Email required';
                }

            },
            validateEmail(mail) {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                    return true;
                }
                return false
            },
            validatePasswordInput(){
                if(this.password.length>7){
                    this.passwordError = "";
                }else{
                    this.passwordError = "invalid password"
                }

                if(!this.password.trim().length){
                    this.passwordError = 'password is required'
                }
            },
            changePassword() {
                if (this.validatePasswordForm()) {
                    let uri = window.App.globalData.routes.change_password;
                    let loading = this.$loading({fullscreen: true});
                    axios.put(uri, this.passwordPayload).then(response => {
                        this.showPasswordModal = false;
                        loading.close();
                        this.$notify({
                            title: 'Success',
                            message: response.data.response.message,
                            type: 'success'
                        });
                    }).catch(e => {
                        console.log(e.response);
                        loading.close();
                        this.$Modal.error({
                            title: 'Change Password Error',
                            content: e.response.data.response.message
                        });

                    });
                }
            },
            validatePasswordForm() {
                let hasError = false;
                this.validatingPassword = true;
                for (let x in this.changePasswordErrors) {
                    if (this.changePasswordErrors[x]) {
                        hasError = true;
                    }
                }
                return !hasError;
            },
            beforeAvatarUpload(file) {
                // const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                // if (!isJPG) {
                //     this.$message.error('La imagen debe estar en formato JPG!');
                // }
                if (!isLt2M) {
                    this.$message.error('The image is too large than 2MB!');
                }
                // return isJPG && isLt2M;
                return isLt2M;
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = res.data.url;
                kinfEvents.$emit('TeachersAvatarAdded',res.data.url);
            },
            openBrowserImage(){
                $('#triggerIcon').click();
                $('#imageUploader').click();
            },
            removeImage(){
                let uri = window.App.globalData.routes.post_remove_image;
                let loading = this.$loading({fullscreen:true});
                axios.delete(uri).then(response=>{
                    loading.close();
                    this.imageRemoved = true;
                    this.$notify({
                        title: 'Success',
                        message: response.data.response.message,
                        type: 'success'
                    });
                    this.imageAdded = null;
                    this.showRemoveAvatarModal = false;
                    kinfEvents.$emit('TeachersAvatarRemoved');
                }).catch(e=>console.log(e));
            }
        },
        created() {
            this.id = String(Math.floor(Math.random() * 1000));
        }


    }
</script>
<style lang="less">
    .vertical-center-modal {
        display: flex;
        align-items: center;
        justify-content: center;

        .ivu-modal {
            top: 0;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-upload__input {
        display: none !important;
    }

    .el-dropdown-menu {
        border-radius: 14px;
        overflow: hidden;
        padding: 1px 0px 0px 0px !important;
    }


    .el-dropdown-menu__item {
        padding: 8px;
        font-size: 18px !important;
        line-height: 26px !important;
        font-family: "Rubik-Regular" !important;
    }

    .el-dropdown-menu__item{
        color:#4a4a4a !important;

    }
    .el-dropdown-menu__item>a{
        color:#4a4a4a !important;

    }
    .el-dropdown-menu__item:active {
        color: white !important;
        background: #D9232E !important;
    }

    .el-dropdown-menu__item:active > a {
        color: white !important;
        background: #D9232E !important;
    }

    .el-dropdown-menu__item:hover {
        color: white !important;
        background: #D9232E !important;
    }

    .el-dropdown-menu__item:hover > a {
        color: white !important;
        background: #D9232E !important;
    }

    .title-6.red-hover{
        color: #fb202d !important;
    }
    .edit-mask{
        height: 178px;
        width: 178px;
        margin: auto;
        border-radius: 89px;
        margin-top: -185px;
        z-index: 1013;
        background: rgba(200,200,200,.3);
        background-size: 30%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        /*filter: blur(5px);*/
        background-image: url('/images/edit-image-icon.png');
        /*transform: scale(1.1);*/
    }

    .click-mask{
        cursor:pointer;
        position: absolute;
        height: 178px;
        width: 178px;
        margin: auto;
        z-index: 1013;
    }

    .edit-mask:hover{
        opacity: 0.9;
    }

    .fa.fa-trash.close:hover{
        opacity: 1 !important;
    }

    .fa.fa-trash.close{
        position: relative;
        z-index: 1014;
        opacity: .8;
        margin-top: 5px;
        margin-right: 5px;
        border-radius: 100%;
        border: 1px solid #d9232e;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #d9232e;
        font-weight: bold;
        font-size: 21px;
    }
    .avatar-uploader-icon{
        height: 178px;
        width: 178px;
        border: 1px dashed #4a4a4a;
    }

    .centerImage{
        position: absolute;
        top: 75px;
        left: 75px;
    }

    .teacher-avatar-modal {
        position: relative;
        width: 178px;
        height: 178px;
        -webkit-border-radius: 89px;
        -webkit-background-clip: padding-box;
        -moz-border-radius: 89px;
        -moz-background-clip: padding;
        border-radius: 89px;
        background-clip: padding-box;
        margin: 7px 0 0 5px;
        /*float: left;*/
        background-size: cover;
        background-position: center center;
    }

    p.max-size{
        font-family: Rubik-Regular;
        font-size: 16px;
        color: #4a4a4a;
        text-align: center;
        margin-top: 15px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/LoginButton.vue